import Component from '../core/Component'
import InputMask from 'inputmask'

export default class DateMask extends Component {

    constructor(element) {
        super(element)

        this.pattern = this.element.pattern || '(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.([12][0-9][0-9][0-9])'
        this.placeholder = this.element.placeholder || 'DD.MM.YYYY'
    }

    prepare() {
        this.mask = new InputMask({
            regex: this.pattern,
            placeholder: this.placeholder
        })
        this.mask.mask(this.element)
    }

}